import { connect } from 'react-redux';

import FloatingPanelMobile from 'src/components/FloatingPanelMobile';

import { getIsHotelOnly, getIsWhitelabel } from 'src/store/view/selectors';

import {
  isMapViewSelector,
  popupDataSelector,
} from '../../store/map/selectors';
import { isSubscribedOnPriceSelector } from '../../store/priceSubscription/selectors';

import { toggleMap as toggleMapAction } from '../../store/map/slice';
import {
  toggleFiltersAction,
  toggleSubscribeAction,
  analyticsClickBellSubscribe,
} from '../../actions/view';
import { setVisibleHotels } from '../../store/hotels/slice';

const mapStateToProps = (state) => ({
  mapView: isMapViewSelector(state),
  isPopupOnMapOpened: !!popupDataSelector(state),
  isSubscribed: isSubscribedOnPriceSelector(state),
  isWhitelabel: getIsWhitelabel(state),
  isHotelOnly: getIsHotelOnly(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleFilters: () => dispatch(toggleFiltersAction(true)),
  toggleMap: () => dispatch(toggleMapAction()),
  setVisibleHotelsLimit: (newVisibleLimit: number) =>
    dispatch(setVisibleHotels(newVisibleLimit)),
  toggleSubscribe: () => {
    dispatch(toggleSubscribeAction());
    dispatch(analyticsClickBellSubscribe());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FloatingPanelMobile);
